import clsx from "clsx";
import {
  // BlueMedal,
  // Bronze,
  // Gold,
  RMCCrown,
  // Silver,
} from "../../../../../components/svg/GeneralIcons";
import { Avatar } from "../../../../../components/Avatar";
// import { ProfileBadge } from "../../../../../components/world/rmc/ProfileBadge";
import { getValidImageUrl } from "../../../../../utils";

export const List = ({ data, isloading, primaryColor = "#FFD700" }) => {
  const loadingLength = new Array(6).fill("_");
  return (
    <div className="max-h-[61vh] h-full overflow-y-scroll hidden-scrollbar">
      {isloading ? (
        <div className="space-y-4 mt-4 px-3">
          {loadingLength.map((_, i) => (
            <div
              key={i}
              className="h-[76px] bg-gray-600 rounded-lg animate-pulse"
            ></div>
          ))}
        </div>
      ) : data?.leaderboard?.length === 0 ? (
        <div className="flex justify-center items-center h-[57vh] flex-col gap-3">
          <p className="tracking-tighter text-2xl font-semibold text-white mx-0 text-center">
            No Leaderboard Data
          </p>
          <p className="text-sm font-medium mt-1 text-[#FFFFFF80] w-full max-w-[300px] text-center">
            Once participants start competing, the leaderboard will show up
            here.
          </p>
        </div>
      ) : (
        data?.leaderboard?.map((x, index) => {
          const audienceId = data.audience;
          const user = x.audience;
          const BadgeName = x.audience?.audience_badges[0]?.badge?.name;
          // const isEven = index % 2 === 0;
          const number = index + 1;

          const getDisplayName = () => {
            const firstName = user?.first_name?.trim();
            const lastName = user?.last_name?.trim();
            const hasName = firstName || lastName;

            if (x.audience_id === audienceId) {
              // Current user
              return hasName
                ? `${firstName || ""} ${lastName || ""}`.trim()
                : "YOU";
            } else {
              // Other users
              return hasName
                ? `${firstName || ""} ${lastName || ""}`.trim()
                : "Anonymous";
            }
          };

          const displayName = getDisplayName();

          return (
            <div
              className={clsx(
                x.audience_id === audienceId ? "" : "bg-[#1B2033]",
                "flex items-center rounded-[10px] w-full justify-between my-3 px-3 py-4 drop-shadow-sm",
              )}
              style={x.audience_id === audienceId ? { backgroundColor: primaryColor } : undefined}
              key={index}
            >
              <div className="flex items-center gap-2.5 880:gap-4">
                <div className="flex items-center relative">
                  <p
                    className={clsx(
                      x.audience_id === audienceId
                        ? "text-[#000000]"
                        : "text-yellow-rmc_main",
                      "  font-medium",
                    )}
                  >
                    {number === 1 ? (
                      <RMCCrown
                        fill={
                          number === 1 && x.audience_id === audienceId
                            ? "#1B2033"
                            : primaryColor
                        }
                      />
                    ) : (
                      number
                    )}
                  </p>
                </div>

                {x.audience.profile_image ? (
                  <div
                    className={clsx(
                      x.audience_id === audienceId
                        ? "border-gradient_3"
                        : "border-gradient_2",
                      "p-0.5 rounded-full w-fit cursor-pointer",
                    )}
                  >
                    <img
                      className="w-10 h-10 object-cover rounded-full"
                      src={x.audience.profile_image}
                      alt="Profile_image"
                    />
                  </div>
                ) : (
                  <Avatar
                    name={displayName}
                    size="sm"
                    customBgColor={
                      x.audience_id !== audienceId ? primaryColor : "#1B2033"
                    }
                    className={
                      x.audience_id === audienceId ? primaryColor : "#1B2033"
                    }
                  />
                )}
                <div>
                  <p
                    className={clsx(
                      x.audience_id === audienceId
                        ? "!text-black"
                        : "text-[#FFFFFF]",
                      "font-medium text-base leading-tight tracking-tight",
                    )}
                  >
                    {displayName}
                  </p>
                  <p
                    className={
                      " text-[#FFFFFF80] bg-[#141824] font-normal rounded-[100px] text-[10px] px-2 py-0.5 leading-tight tracking-tight"
                    }
                  >
                    {x.total_score} pts. {BadgeName}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                {user?.audience_badges?.map((y) => {
                  const badgeName = y?.badge?.name;

                  const imageUrl = getValidImageUrl(
                    y?.badge?.image_url,
                    "/image/BronzeMedal.png",
                  );
                  return (
                    <img
                      key={y.id}
                      src={imageUrl}
                      alt={badgeName || "User current badge"}
                      className="w-[18px] h-[23px] object-contain"
                    />
                  );
                })}

                {/* {isEven && <BlueMedal />} */}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};
